import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {BehaviorSubject, Observable} from 'rxjs';
import {WalkThroughStep, WalkThroughStepsList} from '../../types/walkthough.type';
import {AutoUnsubscribe} from '../../decorators/auto-unsubscribe.decorator';
import {UserApiService} from '../../services/api/users-api.service';
import {MySitesApiService} from '../../services/api/my-sites-api.service';
import {MCActionsService} from '../../services/mc-base/mc-actions-service';
import {ActivityTrackingService} from '../../auth/shared/services/activity-tracking.service';
import {ToastrMessagesProvider} from '../../services/toastr-messages.service';
import {UserInfoQuery} from '../../common/elf-store/user-info/user-info.query';
import {UserInfoState} from '../../common/elf-store/user-info/user-info.type';
import {WalkthroughStatusType} from '../../../userway/sdk/UserWayApiClient';

@Injectable({
  providedIn: 'root',
})
@AutoUnsubscribe()
export class WalkTroughService extends MCActionsService {
  private activeStep$: BehaviorSubject<WalkThroughStep> = new BehaviorSubject(null);
  private steps: WalkThroughStep[] = [];
  private userId: string;
  private walkthroughActivated: boolean = false;

  constructor(
    private router: Router,
    private userApiService: UserApiService,
    private sieApiService: MySitesApiService,
    private toastr: ToastrMessagesProvider,
    private readonly activityTrackingService: ActivityTrackingService,
    userInfoQuery: UserInfoQuery,
  ) {
    super(userInfoQuery);
    this.initialized$.next(true);
  }

  get stepsCount(): number {
    return this.steps.length;
  }

  get currentStepIndex(): number {
    return this.steps.findIndex(step => step.name === this.activeStep.name);
  }

  get activeStep(): WalkThroughStep {
    return this.activeStep$.value;
  }

  get activeStepUpdates$(): Observable<WalkThroughStep> {
    return this.activeStep$.asObservable();
  }

  mcOnLogin(userInfo: UserInfoState) {
    // TODO: Can we remove this?
    // UM-2281 disable walkthrough
    return;
    const {walkthroughStatus, id} = userInfo;
    const walkthroughIsCompleted = walkthroughStatus?.[WalkthroughStatusType.MAIN];
    if (this.walkthroughActivated || walkthroughIsCompleted || !id) {
      return;
    }
    this.userId = id;
    this.steps = WalkThroughStepsList;
    const firstStep = WalkThroughStepsList[0];
    this.activeStep$.next(firstStep);
    if (firstStep.route) {
      this.router.navigate([firstStep.route]);
    }
    this.walkthroughActivated = true;
    this.activityTrackingService.startWalkthroughEvent();
  }

  mcOnLogout() {
    this.walkthroughActivated = false;
  }

  async nextStep() {
    const nextIndex = this.currentStepIndex + 1;
    const nextStep = this.steps[nextIndex];

    if (nextStep.route) {
      this.router.navigate([nextStep.route]);
    }

    this.activeStep$.next(this.steps[nextIndex]);
    this.activityTrackingService.nextWalkthroughStepEvent(this.currentStepIndex);
  }

  stopIntro(complete: boolean = false): void {
    complete
      ? this.activityTrackingService.completeWalkthroughEvent()
      : this.activityTrackingService.stopWalkthroughEvent(this.currentStepIndex + 1);

    this.activeStep$.next(null);
    this.steps = null;

    this.userApiService.updateWalkthroughStatus(WalkthroughStatusType.MAIN).subscribe(() => {
      if (complete) {
        this.toastr.success('Congratulations on completing the Walkthrough!');
      }
    });
  }
}
